import { render, staticRenderFns } from "./new-account.vue?vue&type=template&id=82b19370&"
import script from "./new-account.vue?vue&type=script&lang=js&"
export * from "./new-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports